import { useEffect } from 'react';
import EstadoForm from '../../components/estados/EstadoForm';
import { useEstadosStore, type RegistrarEstado } from '../../stores/estados/estados.store';

const AgregarEstado = () => {
  const { current: estado, nuevo, registrar } = useEstadosStore((state) => state);

  useEffect(() => {
    nuevo();
  }, []);

  const handleSave = (values: RegistrarEstado) => {
    return registrar(values);
  };

  return <EstadoForm esAgregar={true} estado={estado} onSave={handleSave} />;
};

export default AgregarEstado;
